/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CreativePreviewFormat {
  DESKTOP_FEED_STANDARD = "DESKTOP_FEED_STANDARD",
  FACEBOOK_STORY_MOBILE = "FACEBOOK_STORY_MOBILE",
  INSTAGRAM_REELS = "INSTAGRAM_REELS",
  INSTAGRAM_STANDARD = "INSTAGRAM_STANDARD",
  INSTAGRAM_STORY = "INSTAGRAM_STORY",
  MESSENGER_MOBILE_INBOX_MEDIA = "MESSENGER_MOBILE_INBOX_MEDIA",
  MOBILE_FEED_STANDARD = "MOBILE_FEED_STANDARD",
  MOBILE_NATIVE = "MOBILE_NATIVE",
}

export enum UserType {
  CSM = "CSM",
  Publisher = "Publisher",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
